'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Divider = (0, _createReactClass2['default'])({
  displayName: 'Divider',

  propTypes: {
    className: _propTypes2['default'].string,
    rootPrefixCls: _propTypes2['default'].string
  },

  getDefaultProps: function getDefaultProps() {
    // To fix keyboard UX.
    return { disabled: true };
  },
  render: function render() {
    var _props = this.props,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        rootPrefixCls = _props.rootPrefixCls;

    return _react2['default'].createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
  }
});

exports['default'] = Divider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-menu/lib/Divider.js
// module id = 2547
// module chunks = 0